import { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useCRUD } from '../../../../api/crud';
import { USERS_URL } from '../../../../api/users';
import { User } from '../../../../types/users';
import { useHasPermission } from '../../../../contexts/auth';
import { useBreadcrumbs } from '../../../../components/ui/breadcrumps/breadcrumbsContext';
import { DetailPage } from '../../../../components/ui/detailView';
import { UserAccountDetail } from '../../../../components/userAccountDetail/userAccountDetail.component';

export const TenantUserDetail = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { loading, get } = useCRUD(USERS_URL);
  const { setOverride } = useBreadcrumbs();
  const [user, setUser] = useState<User | undefined>();
  const canViewUsers = useHasPermission("users.view_user");

  const fetchUser = useCallback(async () => {
    if (!id) return;

    const result = await get(id);

    if (result?.success && result?.data) {
      setUser(result.data);
      const userName = [result.data.first_name, result.data.last_name]
        .filter(Boolean)
        .join(' ') || result.data.email || '';
      setOverride(`/tenant/users/${id}`, userName);
    } else {
      navigate('/tenant/users');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, get, navigate]);

  useEffect(() => {
    fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.addEventListener('tenantUpdated', fetchUser);

    return () => {
      window.removeEventListener('tenantUpdated', fetchUser);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!canViewUsers) {
    return null;
  }

  if (loading || !user) {
    return <DetailPage loading />;
  }

  return <UserAccountDetail user={user} />;
};
